<template>
  <div id="app">
    <router-view />
    <error-modal
      :is-open-modal="isError"
      :errors="errors"
      :message="message"
      @closed="clearErrors"
    />
  </div>
</template>

<script>
import {actionType, getterTypes as authGetterTypes} from '@/store/modules/auth'
import {find, head, pipe, reject, whereEq} from 'ramda'
import {mapGetters, mapState} from 'vuex'
import ErrorModal from '@/components/modals/ErrorModal'
import {mutationTypes} from '@/store/modules/errors/erorrs'

export default {
  components: {ErrorModal},
  computed: {
    ...mapState({
      errors: (state) => state.errors.errors,
      message: (state) => state.errors.message,
      isError: (state) => state.errors.isError,
    }),
    ...mapGetters({
      currentSchoolId: authGetterTypes.currentSchoolId,
    }),
  },
  mounted() {
    if (this.user && !this.currentSchoolId) {
      if (this.user.schools && this.user.schools.length) {
        const allSchool = find(whereEq({type: 'all'}), this.user.schools)
        if (allSchool) {
          return this.$store.dispatch(actionType.setCurrentSchoolId, {
            schoolId: 'all',
            schoolType: 'all',
          })
        } else {
          const school = pipe(
            reject(whereEq({type: 'all'})),
            head
          )(this.user.schools)
          return this.$store.dispatch(actionType.setCurrentSchoolId, {
            schoolId: school.id,
            schoolType: school.type,
          })
        }
      }
    }
  },
  methods: {
    clearErrors() {
      this.$store.commit(mutationTypes.clearErrors)
    },
  },
}
</script>

<style lang="scss"></style>
